import React from "react"

import HotTable from "../utils/hot-table";
import Popup from '../utils/popup'


import InvestmentThemeProjectForm from './project-form-container'

class ProjectComponent extends React.Component {

	render() {
		var headers = this.props.ppi.years.filter(y => (y.year >= this.props.current_year)).map(year => (year.year))
		headers.unshift("Reste")
		headers.unshift("Budget")
		return (
			<div style={{overflow:"auto",paddingBottom:"80px",height:"100%"}}>
				<section>
					{/*
					<InvestmentThemeProjectForm
						ppi={this.props.ppi} 
						project={this.props.project} 
						theme={this.props.theme}
						subtheme={this.props.subtheme}
						onUpdated={this.props.onProjectUpdated} 
					/>*/}
					<HotTable
						root="project"
						title={this.props.project.name}
						headers={headers}
						data={this.props.data}
						current_year={this.props.current_year}
						ppi={this.props.ppi}
						tableDefinition={this.props.tableDefinition}
						onCustomAction={this.props.onCustomAction}
						onChange={this.props.onChange} 
					/>
				</section>
			</div>

		)
	}

	_buildPopupTitle() {
		return ""
	}

	_buildPopupContent() {
		return <div>Content</div>
	}
}

export default ProjectComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/project-component.js